<template>
  <Modal
    :modal-style="{ width: '600px' }"
    title="Send Insights Plus Report"
  >
    <div class="row">
      <div class="q-mb-lg full-width">
        <div class="q-gutter-y-md">
          <h3>Recipients</h3>
          <!-- eslint-disable vue/prefer-true-attribute-shorthand -->
          <QRadio
            v-model="useDistributionList"
            label="Distribution List"
            :val="true"
          />
          <!-- eslint-enable -->
          <QRadio
            v-model="useDistributionList"
            label="Custom List"
            :val="false"
          />
        </div>

        <div v-if="useDistributionList">
          <SelectList
            v-model="insightsReport.distributionListId"
            class="full-width q-mb-lg"
            emit-value
            label="Select Distribution List"
            map-options
            option-label="name"
            :options="distributionLists"
          />
          <span>{{ includedRecipients }}</span>
        </div>
        <div
          v-else
          class="q-mt-md"
        >
          <EmailField
            v-model:recipients="recipients"
            can-clear-recipients
            class="q-mt-xs q-mb-lg q-field--filled q-field__control full-height full-width"
            copy-recipients
            csv-export-recipients
            filter-enabled
            label="Recipients"
            show-count
            @update:recipients="onUpdateRecipients"
          />
        </div>

        <div class="q-mt-xl">
          <h3>Report</h3>
          <div class="row justify-between">
            <div>
              <QRadio
                v-model="versionToSend"
                :disable="!hasAnnotatedReport"
                label="Annotated"
                val="annotated"
              />
              <QRadio
                v-model="versionToSend"
                label="Original"
                val="original"
              />
            </div>
            <QCheckbox
              v-model="includeHtml"
              label="Include HTML Version"
            />
          </div>
        </div>
        <span
          v-if="!hasAnnotatedReport"
          class="row q-ml-sm q-mt-sm"
        >
          <QIcon
            name="error_outline"
            size="20px"
          />
          No Report has been uploaded
        </span>
      </div>
    </div>
    <template #buttons="{ close }">
      <QBtn
        class="q-mr-sm"
        label="Cancel"
        @click.prevent="close"
      />

      <QBtn
        color="primary"
        label="Send"
        @click="sendReport(close)"
      />
    </template>
  </Modal>
</template>

<script>
import EmailField from "shared/components/core/forms/EmailField.vue";
import Modal from "shared/components/core/modals/Modal.vue";
import Organisation from "shared/resources/Organisation";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "EmailInstantInsightsPlusReportModal",
  components: {
    Modal,
    EmailField,
    SelectList,
  },
  props: {
    insightsReport: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "confirm"],
  data() {
    return {
      versionToSend: null,
      useDistributionList: false,
      distributionLists: {},
      recipients: [],
      includeHtml: true,
    };
  },
  computed: {
    hasAnnotatedReport() {
      return this.insightsReport.activeStorageAttachments.length;
    },
    includedRecipients() {
      if (!this.insightsReport.distributionListId) return "";

      return this.selectedDistributionList.recipients.join(", ");
    },
    selectedDistributionList() {
      return this.distributionLists.find(
        ({ id }) => this.insightsReport.distributionListId === id
      );
    },
  },
  mounted() {
    this.loadDistributionLists();

    if (this.insightsReport.distributionListId) {
      this.useDistributionList = true;
    }

    this.versionToSend = this.hasAnnotatedReport ? "annotated" : "original";
  },
  methods: {
    async loadDistributionLists() {
      try {
        const response = await Organisation.select(["id"])
          .selectExtra(["features"])
          .includes(["distributionLists"])
          .select({ distributionLists: ["name", "recipients"] })
          .find(1);

        this.distributionLists = response.data.distributionLists;
      } catch (error) {
        this.$error("Unable to load distribution lists", error);
        this.$emit("close");
      }
    },
    async sendReport(close) {
      try {
        if (!this.useDistributionList) {
          this.insightsReport.distributionListId = null;
        }

        await this.insightsReport.saveResource();

        await this.$streemApiAdmin.post(
          `insights_reports/${this.insightsReport.id}/email`,
          {
            params: {
              version: this.versionToSend,
              include_html: this.includeHtml,
            },
          }
        );

        this.$q.notify("Report has been sent to the selected recipients.");
        this.$emit("confirm");
      } catch (error) {
        this.$error("Unable to email report.", error);
      } finally {
        close();
      }
    },
    onUpdateRecipients(recipients) {
      this.insightsReport.recipients = recipients;
    },
  },
};
</script>
